<template>
  <div class="sub-agent-tab-root">
    <div class="dashboard-base-bg">
      <div class="dashboard-sec-bg">
        <div
          v-if="info && info.subAgentActMaxReward && info.subAgentActTimeStart && info.subAgentActTimeEnd"
          class="activity-card"
          @click="handleViewProgress"
        >
          <div class="card-bg"></div>
          <div class="card-content">
            <MyPLabel class="card-title" :str="$t('lang.Invite.k099')" :numsOption="activityMaxRewardNums"></MyPLabel>
            <div class="date-pill">
              <img class="date-icon" src="@/assets/packageAssets/views/P2_Page/Invite/default/clock.webp" alt="" />
              <span class="date-text">
                {{ handleMoment(info.subAgentActTimeStart, 'D MMM') }} – {{ handleMoment(info.subAgentActTimeEnd, 'D MMM YYYY') }}
              </span>
            </div>
          </div>
          <button type="button" class="view-progress">{{ $t('lang.Invite.k100') }}</button>
        </div>
        <div class="sub-agent-panel">
          <div class="module-switch-tab">
            <div class="module-switch-inner">
              <div class="module-tab" :class="{ 'active-tab': moduleTab === 0 }" @click="handleModuleTab(0)">{{ $t('lang.Invite.k059') }}</div>
              <div class="module-tab" :class="{ 'active-tab': moduleTab === 1 }" @click="handleModuleTab(1)">
                {{ $t('lang.BaseCommon.k031') }}
              </div>
            </div>
          </div>
          <InviteTab v-if="moduleTab === 0" />
          <CommissionTab v-if="moduleTab === 1" :info="info" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import InviteTab from './InviteTab.vue'
import CommissionTab from './CommissionTab.vue'
export default {
  name: 'SubAgentTab',
  components: { InviteTab, CommissionTab },
  props: {
    info: {
      type: Object,
      default: () => undefined,
    },
  },
  data() {
    return {
      moduleTab: 0,
    }
  },
  computed: {
    activityMaxRewardNums() {
      const maxReward = this.info?.subAgentActMaxReward || 0
      return [{ value: maxReward / 1000 }]
    },
  },
  methods: {
    handleModuleTab(index) {
      this.moduleTab = index
    },
    handleViewProgress() {
      this.$router.push({
        path: '/sub-agent-event',
        query: { statusBarHeight: this.$route.query.statusBarHeight },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.sub-agent-tab-root {
  .dashboard-base-bg {
    width: 343px;
    margin: auto;
    background: #d0c6b6;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;

    .dashboard-sec-bg {
      background: #fefefe;
      border-radius: 16px;
      border-top-right-radius: 0;
      padding: 12px;

      .activity-card {
        position: relative;
        width: 100%;
        padding: 13px 12px;
        background: #9b3dff;
        border-radius: 8px;
        overflow: hidden;
        box-sizing: border-box;

        .card-bg {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 100%;
          height: 100%;
          transform: translate(-50%, -50%);
          background: url('~@/assets/packageAssets/views/P2_Page/Invite/default/card-bg.webp') center / cover no-repeat;
          mix-blend-mode: luminosity;
          pointer-events: none;
        }

        .card-content {
          position: relative;
          z-index: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          height: 100%;

          .date-pill {
            margin-top: 6px;
            display: inline-flex;
            align-items: center;
            max-width: calc(100% - 96px);
            padding: 3px 3px 3px 8px;
            background: linear-gradient(90deg, rgba(158, 69, 255, 0.5) 0%, rgba(158, 69, 255, 0) 100%);
            border-radius: 20px;

            .date-icon {
              width: 16px;
              height: 16px;
              margin: 0 2px;
              flex-shrink: 0;
            }

            .date-text {
              margin-inline-start: 2px;
              font-family: var(--string-font);
              font-style: italic;
              font-weight: var(--fw-400);
              font-size: var(--fs-12);
              line-height: var(--lh-label-16);
              color: #ffffff;
              white-space: nowrap;
              direction: ltr;
            }
          }

          .card-title {
            font-family: 'PlusJakartaSans-Regular', var(--string-font);
            font-weight: var(--fw-700);
            font-size: var(--fs-14);
            line-height: var(--lh-title-20);
            color: #ffffff;
          }
        }

        .view-progress {
          position: absolute;
          inset-inline-end: 12px;
          bottom: 8px;
          z-index: 1;
          padding: 4px 12px;
          border: none;
          background: #ffffff;
          border-radius: 44px;
          font-family: var(--string-font);
          font-weight: var(--fw-400);
          font-size: var(--fs-14);
          line-height: var(--lh-title-20);
          color: #872be9;
          white-space: nowrap;
        }
      }

      .sub-agent-panel {
        display: flex;
        flex-direction: column;
        margin-top: 12px;

        .module-switch-tab {
          width: 300px;
          margin: 0 auto;
          padding: 8px 0;

          .module-switch-inner {
            display: flex;
            align-items: center;
            background: #eeeae4;
            border-radius: 36px;
          }

          .module-tab {
            flex: 1;
            padding: 10px 12px;
            font-family: var(--string-font);
            font-weight: var(--fw-400);
            font-size: var(--fs-12);
            line-height: var(--lh-title-20);
            color: #a9a092;
            text-align: center;
            white-space: nowrap;

            &.active-tab {
              border: 4px solid #eeeae4;
              border-radius: 24px;
              color: #ffffff;
              background: linear-gradient(180deg, #f6e0b3 0%, #c6a175 42.788%, #86592e 100%);
            }
          }
        }
      }
    }
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .sub-agent-tab-root {
    .dashboard-base-bg {
      .dashboard-sec-bg {
        border-top-left-radius: 0;
        border-top-right-radius: 16px;

        .activity-card {
          .card-content {
            .date-pill {
              background: linear-gradient(270deg, rgba(158, 69, 255, 0.5) 0%, rgba(158, 69, 255, 0) 100%);
            }
          }
        }
      }
    }
  }
}
</style>
